import { createReducer, on } from '@ngrx/store';
import * as PayWithPointsActions from './pay-with-points.actions';

export interface Exchange {
  fiatAmount: number;
  fiatCurrency: string;
  loyaltyAmount: number;
}

export interface BalanceState {
  points: number;
  loading: boolean;
}

const initialState: BalanceState = {
  points: null,
  loading: false,
};

export const balanceReducer = createReducer(
  initialState,
  on(PayWithPointsActions.getBalance, (state) => ({ ...state, loading: true })),
  on(PayWithPointsActions.getBalanceSuccess, (_state, { points }) => ({ points, loading: false })),
  on(PayWithPointsActions.getBalanceFail, (state) => ({ ...state, loading: false }))
);
